import { analysisActions, useLCATimeseriesPlot, useNodeById } from '@/stores/analysisStore';
import LCAPlotForm from '../lca/LCAPlotForm';
import { ContinuousChart } from './ContinuousChart';
import { DiscreteChart } from './DiscreteChart';
import { getLCAYaxisLabel } from '@/utils/analysisUtils';

export const EmissionsAnalysis = () => {
  const plot = useLCATimeseriesPlot();
  const { nodeId, results } = plot;
  const node = useNodeById(nodeId);
  const updatePlot = formData => analysisActions.updatePlot('lca_timeseries', formData);

  if (!node) return null;

  const yearlyYAxisLabel = `${plot.levelize === 'true' ? 'Normalized' : 'Annual'} Emissions\n[${getLCAYaxisLabel(plot)}]`;
  const cumulativeYAxisLabel = `Cumulative Emissions\n[${getLCAYaxisLabel({ ...plot, levelize: 'false' })}]`;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="min-h-80 p-6">
          <DiscreteChart
            plot={results.yearly}
            label={node.label}
            yAxisLabel={yearlyYAxisLabel}
            startYear={results.start_year}
            endYear={results.end_year}
          />
        </div>
        <div className="min-h-80 p-6">
          <ContinuousChart
            plot={results.cumulative}
            label={node.label}
            yAxisLabel={cumulativeYAxisLabel}
            startYear={results.start_year}
            endYear={results.end_year}
          />
        </div>
      </div>
      <div className="group emissions">
        <LCAPlotForm
          key={nodeId}
          onSubmit={updatePlot}
          defaultValues={plot}
          showYear={false}
          showScope3Breakdown={false}
        />
      </div>
    </div>
  );
};
